export default "__VITE_ASSET__BMa1A5cm__"